import { bl_inv_stock_conversion_hdr_RowClass } from '../../../dbschema/bl_inv_stock_conversion_hdr.model';
import { bl_inv_stock_conversion_line_RowClass } from '../../../dbschema/bl_inv_stock_conversion_line.model';
import {BaseContainerModel} from '../../base-container.model';


export class StockConversionContainerModel extends BaseContainerModel {
  bl_inv_stock_conversion_hdr: bl_inv_stock_conversion_hdr_RowClass = new bl_inv_stock_conversion_hdr_RowClass();
  bl_inv_stock_conversion_line: bl_inv_stock_conversion_line_RowClass[] = [];
}
